import { Text } from '@kanda-libs/ks-design-library';
import useCalculateBorrowAmountButton from './useCalculateBorrowAmountButton';

const CalculateBorrowAmountButton: React.FunctionComponent = function () {
  const { onClick, className, isLoading } = useCalculateBorrowAmountButton();
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      disabled={isLoading}
      aria-label="calculate-borrow-amount"
    >
      <Text
        text="How much can I borrow?"
        className="text-inherit"
        isLoading={isLoading}
      />
    </button>
  );
};

export default CalculateBorrowAmountButton;
